const paths = {
  add: '<path d="M3 12h7m-3-3 3 3-3 3"/><rect x="12" y="6" width="10" height="12" rx="2"/><circle cx="17" cy="12" r="2"/>',
  transfer: '<path d="M3 12h12m-4-4 4 4-4 4M13 4h7a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-7"/>',
  categories: '<path d="M5 20V12m7 8V4m7 16V8"/>',
  calendar: '<rect x="3" y="5" width="18" height="16" rx="3"/><path d="M7 3v4m10-4v4M3 10h18"/>',
  receipt: '<path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 7h6m-6 4h6m-6 4h4"/>',
  edit: '<path d="m4 16 12-12a2 2 0 0 1 4 4L8 20l-5 1zM14 6l4 4"/>',
  link: '<path d="m10 14 4-4m-6 7-1 1a4 4 0 0 1-6-6l4-4a4 4 0 0 1 6 0m2-1 1-1a4 4 0 0 1 6 6l-4 4a4 4 0 0 1-6 0"/>',
  chevron: '<path d="m9 5 7 7-7 7"/>',
};
export function interfaceIcon(name: keyof typeof paths): string {
  return `<svg viewBox="0 0 24 24" aria-hidden="true">${paths[name]}</svg>`;
}
